// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_PreviaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /contratos/previa — o HTML exato que iria ao DocuSign e o que falta preencher. */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contratos_PreviaResponseDados {
html: string
pendencias: string[]
}

export type Contratos_PreviaResponse = ApiResponse<Contratos_PreviaResponseDados>;

registerResponseContract('Contratos_PreviaResponse', {
  html:       { type: 'string',  required: true },
  pendencias: { type: 'array',   required: true },
})
